(() => {
  const POPUP_ID = "BridePopup";
  const popup = document.getElementById(POPUP_ID);
  if (!popup) return;

  const overlay = popup.querySelector("[data-close]");
  const closeBtn = popup.querySelector(".bride-popup__close");
  const continueBtn = popup.querySelector("[data-continue]");
  const errorEl = popup.querySelector(".bride-popup__error");
  const dateWrap = popup.querySelector(".bride-popup__date");
  const dateInput = popup.querySelector('input[name="bride_date"]');

  let activeForm = null;

  // ---------------------------
  // Helpers
  // ---------------------------
  const root =
    window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";

  const isDateEnabledForForm = (form) => {
    const wrapper = form.closest("product-form");
    return !!(wrapper && wrapper.dataset && wrapper.dataset.brideDate === "true");
  };

  const showError = (msg) => {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  };

  const openPopup = (form) => {
    activeForm = form;

    // Reset UI
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = "";
    }

    popup
      .querySelectorAll('input[name="bride_answer"]')
      .forEach((i) => (i.checked = false));

    if (dateInput) dateInput.value = "";
    if (dateWrap) dateWrap.hidden = true;

    popup.hidden = false;
    document.documentElement.classList.add("bride-popup-open");
  };

  const closePopup = () => {
    popup.hidden = true;
    document.documentElement.classList.remove("bride-popup-open");
    activeForm = null;
  };

  const upsertHidden = (form, name, value) => {
    let input = form.querySelector(
      `input[type="hidden"][name="${CSS.escape(name)}"]`
    );
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const removeHidden = (form, name) => {
    const input = form.querySelector(
      `input[type="hidden"][name="${CSS.escape(name)}"]`
    );
    if (input) input.remove();
  };

  // ---------------------------
  // EXACT Prestige add-to-cart flow (mirrors theme.js)
  // ---------------------------
  const prestigeAjaxAddToCart = async (form) => {
    // Validate required variant/options
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // Busy state on submit buttons
    const submitButtons = Array.from(form.elements).filter(
      (el) => el && el.type === "submit"
    );
    submitButtons.forEach((b) => b.setAttribute("aria-busy", "true"));

    // Start loading
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    // Ask theme sections (cart drawer will push its section id here)
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const formData = new FormData(form);

    // IMPORTANT: force open cart drawer on success
    formData.set("on_success", "force_open_drawer");

    // Prestige expects these for section rendering
    formData.set("sections", sectionsToBundle.join(","));

    const idInput = form.querySelector('input[name="id"]');
    const variantId = idInput ? idInput.value : "";
    formData.set("sections_url", `${root}variants/${variantId}`);

    // Add to cart
    const response = await fetch(`${root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    submitButtons.forEach((b) => b.removeAttribute("aria-busy"));

    const responseJson = await response.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );

    if (!response.ok) {
      form.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: responseJson["description"] },
        })
      );
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return;
    }

    // If cart type is page, redirect (safety)
    if (
      window.themeVariables &&
      window.themeVariables.settings &&
      (window.themeVariables.settings.cartType === "page" ||
        window.themeVariables.settings.pageType === "cart")
    ) {
      window.location.href = `${root}cart`;
      return;
    }

    // Get updated cart + attach sections returned by add.js
    const cartContent = await (await fetch(`${root}cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];

    // Dispatch the same events Prestige relies on
    form.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items")
            ? responseJson["items"]
            : [responseJson],
          cart: cartContent,
          onSuccessDo: "force_open_drawer",
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          onSuccessDo: "force_open_drawer",
          cart: cartContent,
        },
      })
    );
  };

  // ---------------------------
  // Popup UI behavior
  // ---------------------------
  popup.addEventListener("change", (e) => {
    const t = e.target;
    if (!t) return;

    if (t.name === "bride_answer") {
      const val = t.value;
      const allowDate = activeForm && isDateEnabledForForm(activeForm);

      // Only show date when product supports date + user selected Yes
      if (dateWrap) dateWrap.hidden = !(allowDate && val === "Yes");

      // Do NOT auto-focus (prevents calendar popping too fast)
      // if (val === "Yes" && dateInput) dateInput.focus();
    }
  });

  overlay && overlay.addEventListener("click", closePopup);
  closeBtn && closeBtn.addEventListener("click", closePopup);

  // Continue: set properties -> AJAX add -> drawer opens via cart:change
  continueBtn &&
    continueBtn.addEventListener("click", async () => {
      if (!activeForm) return;

      const checked = popup.querySelector(
        'input[name="bride_answer"]:checked'
      );
      if (!checked) return showError("Please select an option to continue.");

      const answer = checked.value;
      const allowDate = isDateEnabledForForm(activeForm);

      if (answer === "Yes") {
        upsertHidden(activeForm, "properties[Are you a bride?]", "Yes");

        if (allowDate) {
          if (!dateInput || !dateInput.value) {
            return showError("Please enter the date you need the suit by.");
          }
          upsertHidden(
            activeForm,
            "properties[Date needed by]",
            dateInput.value
          );
        } else {
          // Product does not require date/calendar
          removeHidden(activeForm, "properties[Date needed by]");
        }
      } else {
        upsertHidden(activeForm, "properties[Are you a bride?]", "No");
        removeHidden(activeForm, "properties[Date needed by]");
      }

      const formToSubmit = activeForm;
      closePopup();

      await prestigeAjaxAddToCart(formToSubmit);
    });

  // ---------------------------
  // Intercept submits for tagged products
  // ---------------------------
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes("/cart/add")) return;

      const wrapper = form.closest("product-form");
      const enabled =
        wrapper && wrapper.dataset && wrapper.dataset.bridePopup === "true";
      if (!enabled) return;

      // Stop normal submit (we will handle after popup)
      e.preventDefault();
      e.stopPropagation();
      openPopup(form);
    },
    true
  );
})();
